<!--
* @description  参数1
* @fileName  index
* @author userName
* @date 2024-01-12 11:09:59
!-->
<template>
  <div id="index" class="result-index">
    <div class="result-left">
      <div class="result-left-title">
        <div>Filters</div>
        <div style="cursor: pointer;" @click="reset">clean all</div>
      </div>
      <div>
        <ul class="menu-class">
          <li>
            <div class="menu-title" @click="clkxShow(0)">
              <span>Price</span>
              <i :class="{ 'el-icon-arrow-down':!showList[0].isShow, 'el-icon-arrow-up':showList[0].isShow }" />
            </div>
            <div v-show="showList[0].isShow" class="menu-content">
              <div class="range-title">${{ priceRange[0] }} - ${{ priceRange[1] }}</div>
              <vue-slider
                v-if="priceRange.length>0"
                v-model="priceRange"
                :min="priceMin"
                :max="priceMax"
                :enable-cross="false"
                @drag-end="priceChange"
              />
            </div>
          </li>
          <li>
            <div class="menu-title" @click="clkxShow(1)">
              <span>Expiration date</span>
              <i :class="{ 'el-icon-arrow-down': !showList[1].isShow, 'el-icon-arrow-up': showList[1].isShow }" />
            </div>
            <div v-show="showList[1].isShow" class="menu-content">
              <div class="range-title">${{ timeRange[0] }} - ${{ timeRange[timeRange.length-1] }}</div>
              <vue-slider
                v-if="timeRange.length>0"
                v-model="timeIndexRange"
                :enable-cross="false"
                :tooltip-formatter="formatter"
                :min="minTime"
                :max="maxTime"
                @drag-end="timeChange"
              />
            </div>
          </li>
          <li>
            <div class="menu-title" @click="clkxShow(2)">
              <span>Modes</span>
              <i :class="{ 'el-icon-arrow-down': !showList[2].isShow, 'el-icon-arrow-up': showList[2].isShow }" />
            </div>
            <div v-show="showList[2].isShow" class="menu-content">
              <el-checkbox-group v-model="modesCheckList" @change="modesChange">
                <el-checkbox
                  v-for="(item,index) in modes"
                  :key="index"
                  :label="`${item.name} (${item.count})`"
                />
              </el-checkbox-group>
            </div>
          </li>
          <li>
            <div class="menu-title" @click="clkxShow(3)">
              <span>Origin Port</span>
              <i :class="{ 'el-icon-arrow-down': !showList[3].isShow, 'el-icon-arrow-up': showList[3].isShow}" />
            </div>
            <div v-show="showList[3].isShow" class="menu-content">
              <el-checkbox-group v-model="originPortsCheck" @change="originPortChange">
                <el-checkbox
                  v-for="(item,index) in originPorts"
                  :key="index"
                  :label="`${item.name} (${item.count})`"
                />
              </el-checkbox-group>
            </div>
          </li>
          <li>
            <div class="menu-title" @click="clkxShow(4)">
              <span>Destination Port</span>
              <i :class="{ 'el-icon-arrow-down': !showList[4].isShow, 'el-icon-arrow-up': showList[4].isShow }" />
            </div>
            <div v-show="showList[4].isShow" class="menu-content">
              <el-checkbox-group v-model="destinationPortsCheck" @change="destinationPortChange">
                <el-checkbox
                  v-for="(item,index) in destinationPorts"
                  :key="index"
                  :label="`${item.name} (${item.count})`"
                />
              </el-checkbox-group>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="result-right">
      <div class="result-tab">
        <div
          v-for="(item, index) in tabList"
          :key="index"
          :class="['tab-class', { 'active': selectNumber == index }]"
          @click="clickType(item, index)"
        >
          {{ item.title }}
        </div>
      </div>
      <div>
        <ResultList ref="PriceList" :sort-title="tabList[selectNumber].title" />
      </div>
    </div>
  </div>
</template>

<script>
import ResultList from './resultList.vue'
import {
  QueryPrice
} from '/src/api/checkPrice.js'
export default {
  name: 'Index',
  components: {
    // 组件的引用
    ResultList
  },
  props: {

  },
  data() {
    return {
      data: undefined,
      inputData: undefined,
      showList: [{
        isShow:false,
      },{
        isShow:false,
      },{
        isShow:true,
      },{
        isShow:true,
      },{
        isShow:true,
      },],
      // ----------可拖拽选择范围组件
      priceRange: [],
      priceMin: 0,
      priceMax: 0,
      // 多选框
      modesCheckList: [],
      // /  tab切换
      tabList: [{
        title: 'Best value',
        sortType: 1
      },
      {
        title: 'Quickest',
        sortType: 2
      },
      {
        title: 'Cheapest',
        sortType: 3
      }
      ],
      selectNumber: 0,
      bindData: undefined,
      timeRange: [],
      timeIndexRange: [],
      minTime: 0,
      maxTime: 0,
      modes: [],
      destinationPorts: [],
      destinationPortsCheck: [],
      originPorts: [],
      originPortsCheck: [],
      formatter: (v) => this.timeRange[v]
    }
  },
  computed: {
    // 计算属性
  },
  watch: {},
  created() {
    // 实例被创建之后执行代码

  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    reset() {
      this.modesCheckList = []
      this.originPortsCheck = []
      this.destinationPortsCheck = []
      this.init(this.data, this.inputData)
    },
    destinationPortChange(val) {
      if (val.length > 0) {
        var selectList = []
        val.forEach(item => {
          selectList.push(item.split('(')[0].trim())
        })
        this.bindData = this.data.list.filter(item => {
          return selectList.indexOf(item.destPortCode) >= 0 || selectList.indexOf(item
            .destinationName) >= 0
        })
      } else {
        this.bindData = this.data.list
      }
      this.$nextTick(() => {
        this.$refs.PriceList.init(this.bindData, this.inputData)
      })
    },
    originPortChange(val) {
      if (val.length > 0) {
        var selectList = []
        val.forEach(item => {
          selectList.push(item.split('(')[0].trim())
        })
        this.bindData = this.data.list.filter(item => {
          return selectList.indexOf(item.startPortCode) >= 0 || selectList.indexOf(item
            .originName) >= 0
        })
      } else {
        this.bindData = this.data.list
      }
      this.$nextTick(() => {
        this.$refs.PriceList.init(this.bindData, this.inputData)
      })
    },
    modesChange(val) {
      var selectModes = []
      var codes = []
      val.forEach(item => {
        selectModes.push(this.modes.find(p => item.indexOf(p.name) >= 0).value)
        if (item.indexOf('LCL+Express') >= 0) {
          codes.push('3')
        }
        if (item.indexOf('LCL+Truck') >= 0) {
          codes.push('5')
        }
      })
      if (selectModes.length == 0) {
        this.bindData = this.data.list
      } else {
        this.bindData = this.data.list.filter(item => {
          var lcl = item.businessType === 3 && codes.indexOf(item.modeCodes) >= 0
          var other = item.businessType !== 3 && selectModes.indexOf(item.businessType) >= 0
          return lcl || other
        })
      }
      this.$nextTick(() => {
        this.$refs.PriceList.init(this.bindData, this.inputData)
      })
    },
    timeChange(val) {
      var startTime = new Date(this.timeRange[this.timeIndexRange[0]])
      var endTime = new Date(this.timeRange[this.timeIndexRange[1]])
      this.bindData = this.data.list.filter(item => {
        var expirationTime = new Date(item.expirationTime)
        return expirationTime >= startTime && expirationTime <= endTime
      })
      this.$nextTick(() => {
        this.$refs.PriceList.init(this.bindData, this.inputData)
      })
    },
    priceChange(val) {
      this.bindData = this.data.list.filter(item => {
        return item.totalAmount >= this.priceRange[0] && item.totalAmount <= this.priceRange[1]
      })
      this.$nextTick(() => {
        this.$refs.PriceList.init(this.bindData, this.inputData)
      })
    },
    init(data, inputData) {
      this.data = data
      this.inputData = inputData
      this.$nextTick(() => {
        this.$refs.PriceList.init(data.list, inputData)
        var price = data.list.map(item => item.totalAmount)
        this.priceMax = parseInt(Math.max(...price))
        this.priceMin = parseInt(Math.min(...price))
        this.priceRange = [this.priceMin, this.priceMax]
        this.timeRange = data.timeRange
        this.timeIndexRange = [0, this.timeRange.length - 1]
        this.minTime = 0
        this.maxTime = this.timeRange.length - 1
        this.modes = data.modes
        this.originPorts = data.originPorts
        this.destinationPorts = data.destinationPorts
      })
    },
    // 方法
    // 点击标题展开内容
    clkxShow(index) {
      this.showList[index].isShow = !this.showList[index].isShow
    },
    clickType(item, index) {
      this.selectNumber = index
      this.inputData.SortType = item.sortType
      // 查价
      QueryPrice(this.inputData).then(res => {
        if (res.code === 200) {
          this.init(res.data, this.inputData)
        }
      })
    },
    initPrice(inputData) {
      QueryPrice(inputData).then(res => {
		  if (res.code === 200) {
		    this.init(res.data, inputData)
		  }
      })
    }
  }
}
</script>
<style scoped lang='scss'>
	.result-index {
		padding-top: 24px;
		display: flex;

		.result-left {
			width: 280px;
			margin-right: 26px;
			background: #FFFFFF;
			border-radius: 8px;

			.result-left-title {
				height: 48px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 0 16px;
			}

			.menu-class {
				padding-left: 8px;
				margin: 0;

				li {
					overflow: hidden;
					cursor: pointer;

					.menu-title {
						height: 40px;
						justify-content: space-between;
						display: flex;
						margin: 0 16px 0 8px;
						align-items: center;
					}

					.menu-content {
						width: 232px;
						//height: 41px;
						background: rgba(242, 244, 248, 0.56);
						border-radius: 8px;
						padding: 16px;

						.range-title {
							text-align: left;
							font-size: 13px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							color: #333333;
							margin-bottom: 8px;
						}

						::v-deep .el-checkbox {
							display: flex;
							margin: 6px 0;
						}
					}
				}
			}
		}

		.result-right {
			.result-tab {
				cursor: pointer;
				width: 894px;
				height: 40px;
				background: #EFF1F5;
				border-radius: 20px;
				display: flex;
				align-items: center;
				font-size: 16px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				color: #777777;

				.tab-class {
					width: 298px;
					height: 40px;
					line-height: 40px;
					font-size: 14px;
				}

				.active {

					background: #FFFFFF;
					border-radius: 20px;
					font-size: 14px;
					font-family: D-DINExp, D-DINExp;
					font-weight: bold;
					color: #E95506 !important;
					padding: 0 8px;
				}

			}
		}
	}
</style>
